export default __webpack_public_path__ + "static/media/108283.26ee6a19.png";